module.exports = __webpack_public_path__ + "static/media/4_multifiber_A_BW_square.ed50130d.png";